import { ControlLabel, FormControl, FormGroup } from 'react-bootstrap';
import PropTypes from 'prop-types';
import React from 'react';

import './TextArea.css';

function TextArea(props, _ref) {
  var form = _ref.form;
  var disabled = props.disabled,
      name = props.name,
      label = props.label,
      required = props.required,
      placeholder = props.placeholder;


  var validation = form.get(name) ? 'success' : null;

  var formLabel = label && React.createElement(
    ControlLabel,
    null,
    label,
    ' ',
    required && React.createElement(
      'span',
      { className: 'text-danger' },
      '*'
    )
  );

  return React.createElement(
    FormGroup,
    { className: 'TextArea', validationState: validation },
    formLabel,
    React.createElement(FormControl, {
      componentClass: 'textarea',
      disabled: Boolean(disabled),
      placeholder: placeholder,
      rows: props.rows,
      value: form.get(name),
      onChange: function onChange(e) {
        return form.set(name, e.target.value);
      }
    })
  );
}

TextArea.contextTypes = {
  form: PropTypes.object.isRequired
};

TextArea.propTypes = process.env.NODE_ENV !== "production" ? {
  disabled: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  rows: PropTypes.number
} : {};

export default TextArea;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bodyspec-form-builder/es/Fields/TextArea.js
// module id = 721
// module chunks = 0